import { getClassNames } from '@/utils/helpers';
import { Status } from '@yaradigitallabs/ahua-react';
import React from 'react';

type LoaderPlaceholderProps = React.ComponentProps<typeof Status>;

export const LoaderPlaceholder: React.FC<LoaderPlaceholderProps> = ({
  colorType = 'gray',
  size = 's',
  className = '',
  children = 'Label',
  ...rest
}) => {
  return (
    <Status
      colorType={colorType}
      size={size}
      className={getClassNames('[&_label]:invisible', className || '')}
      {...rest}
    >
      {children}
    </Status>
  );
};
